import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/date-duration',
  component: () => import('../../routes/DateDurationCalculator.svelte'),
  card: {
    id: 'date-duration',
    title: 'Date Duration',
    description: 'Calculate the exact duration between two dates in days, weeks, months, and years.',
    icon: 'calendar_month',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/date-duration',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Date Duration Calculator – Calculate Days Between Dates',
    description: 'Free date duration calculator to calculate the exact time between two dates. Get days, weeks, months, and years. Includes business day calculation excluding weekends.',
  },
};

export default meta;
